import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

import LazyHydrate from 'react-lazy-hydration'

import Box from 'app/components/base/Box/Box'
import useBoolean from 'app/hooks/useBoolean'
import LocalStorage from 'app/services/Storage'
import useAuthStore, { hasLicense } from 'app/store/auth.store'
import { STORAGE_KEYS } from 'app/utils/constants/storage.constants'

const LicenseInformation = dynamic(
  () => import('app/components/common/LicenseInformation'),
  {
    ssr: false
  }
)

const PopupsWrapAcceptingInformation: RFC = () => {
  const { pathname } = useRouter()
  const [open, handlers] = useBoolean()
  const onPages = ['/sign-up']

  const isLicense = useAuthStore(hasLicense)
  const isOnPage = !!onPages.find((page) => pathname.indexOf(page) !== -1)
  const isShowLicense = !isLicense && !isOnPage

  useEffect(() => {
    setTimeout(() => {
      LocalStorage.getItem(STORAGE_KEYS.cookies).then((res) => {
        if (!res) handlers.on()
      })
    }, 5000)
  }, [])

  return (
    <>
      {(isShowLicense || open) && (
        <LazyHydrate whenVisible>
          <Box
            sx={{
              width: '100vw',
              position: 'fixed',
              bottom: { xs: 8, md: 16 },
              zIndex: 1301
            }}
          >
            <Box
              sx={{
                maxWidth: 1200,
                width: '100%',
                margin: '0 auto',
                px: { xs: 2, md: 5.4 },
                position: 'relative'
              }}
            >
              {isShowLicense && (
                <Box
                  sx={{
                    display: { md: 'flex', xs: 'none' },
                    position: 'absolute',
                    bottom: open ? 168 : 0
                  }}
                >
                  <LicenseInformation />
                </Box>
              )}
            </Box>
          </Box>
        </LazyHydrate>
      )}
    </>
  )
}

export default PopupsWrapAcceptingInformation
